import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, ref, watch } from 'vue';
import NewsItem from '~/components/sections/newsSection/NewsItem.vue';
import { useSwiperElement } from '~/composables';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LatestNews',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };

const ALL_TAGS = 'All tags';



const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
};

const swiperEl = useSwiperElement(swiperOptions);

const activeTag = ref(ALL_TAGS);

const visibleNews = computed(() =>
  activeTag.value === ALL_TAGS
    ? props.data.items
    : props.data?.items?.filter((item: any) =>
        item.tags?.includes(activeTag.value),
      ),
);

const allTags = computed<string[]>(() => {
  const tags = [
    ...new Set(
      props.data?.items
        ?.map((item: any) => item.tags ?? [])
        .flat()
        .filter(Boolean),
    ),
  ] as string[];

  if (tags.length) tags.unshift(ALL_TAGS);
  return tags;
});

watch(visibleNews, () => {
  nextTick(() => swiperEl.value?.swiper?.update());
});

const selectTag = (tag: string) => {
  activeTag.value = activeTag.value === tag ? ALL_TAGS : tag;
};

return { __sfc: true,ALL_TAGS, props, swiperOptions, swiperEl, activeTag, visibleNews, allTags, selectTag, NewsItem }
}

})